module.exports = __webpack_public_path__ + "static/media/loader-128.f1a6967f.gif";